import React from "react";

import {
  formatSkillFrontmatterEntryLabel,
  type SkillFrontmatterEntry,
  type SkillFrontmatterEntryGroup,
} from "../skill-frontmatter";

export interface FrontmatterReadViewProps {
  topLevelEntries: SkillFrontmatterEntry[];
  groups: SkillFrontmatterEntryGroup[];
}

export const FrontmatterReadView = ({ topLevelEntries, groups }: FrontmatterReadViewProps) => (
  <div className="grid gap-x-4 gap-y-1.5 px-3 pb-2 sm:grid-cols-[minmax(100px,160px)_1fr]">
    {topLevelEntries.map((entry) => (
      <React.Fragment key={entry.key}>
        <div className="text-sm font-medium text-gray-500">
          {formatSkillFrontmatterEntryLabel(entry.key)}
        </div>
        <div className="break-words text-sm text-gray-900">{entry.value || "-"}</div>
      </React.Fragment>
    ))}
    {groups.map((group) => (
      <React.Fragment key={group.groupKey}>
        <div className="col-span-full pt-1.5 text-[11px] font-semibold uppercase tracking-wide text-gray-500">
          {formatSkillFrontmatterEntryLabel(group.groupKey)}
        </div>
        {group.entries.map((entry) => (
          <React.Fragment key={`${group.groupKey}.${entry.key}`}>
            <div className="pl-3 text-sm font-medium text-gray-500">
              {formatSkillFrontmatterEntryLabel(entry.key)}
            </div>
            <div className="break-words text-sm text-gray-900">{entry.value || "-"}</div>
          </React.Fragment>
        ))}
      </React.Fragment>
    ))}
  </div>
);
